import './list.sass'

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Collapse } from 'react-collapse';

import ContentLoader from 'controls/content-loader/ContentLoader';
import Item from 'components/track-templates/item/Item';

import request from 'actions/request';
import transmit from 'actions/transmit';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false
    };
  }

  componentDidMount() {
    this.props.request(
      ['trackTemplate', 'getAll'],
      'get',
      'TRACK_TEMPLATES',
      { trackId: this.props.trackId }
    ).then((resp) => {
      if (resp.length < 1) {
        return;
      }

      let defaultIndex = resp.findIndex((item)  => {
        return item.servicePurpose
          && item.servicePurpose.isDefault === true;
      });

      if (defaultIndex === -1) {
        return;
      }

      this.props.transmit(
        'CHOOSE_TRACK_TEMPLATE',
        { id: resp[defaultIndex].id }
      );
    });
  }

  buildTemplatesList() {
    let list = [];
    this.props.trackTemplates.items.forEach((item, index) => {
      list.push(<Item
        key={ index }
        id={ item.id }
        name={ item.name }
        paramCodes={ item.paramCodes.join(', ') }
        params={ item.params }
        servicePurpose={ item.servicePurpose }
        trackId={ this.props.trackId }
      />);
    });

    return list;
  }

  buildBody() {
    if (this.props.pending !== false) {
      return <ContentLoader/>
    } else {
      return this.buildTemplatesList();
    }
  }

  render () {
    return (
      <div className='track-templates-list container-fluid'>
        { this.buildBody() }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pending: state.trackTemplates.pending,
    trackTemplates: state.trackTemplates,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(List);
